<script>
export default {
  name: 'DonutEmpresas',
  props: {
    labels: {
      type: Array,
      default: () => []
    },
    data: {
      type: Array,
      default: () => []
    },
    detalle: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartInstance: null
    };
  },
  computed: {
    chartData() {
      if (!this.labels || this.labels.length === 0) {
        return {
          labels: [],
          datasets: []
        };
      }

      return {
        labels: this.labels,
        datasets: [{
          data: this.data,
          backgroundColor: this.labels.map(label => this.getColorForEmpresa(label)),
          borderColor: '#ffffff',
          borderWidth: 2
        }]
      };
    },

    chartOptions() {
      const self = this;
      return {
        responsive: true,
        maintainAspectRatio: false,
        cutoutPercentage: 60,
        legend: {
          position: 'bottom',
          labels: {
            padding: 15,
            fontSize: 12,
            fontColor: '#333',
            usePointStyle: true
          }
        },
        tooltips: {
          backgroundColor: 'rgba(0,0,0,0.9)',
          titleFontColor: 'white',
          bodyFontColor: 'white',
          borderColor: 'rgba(255,255,255,0.3)',
          borderWidth: 1,
          cornerRadius: 6,
          callbacks: {
            title: function(tooltipItems, data) {
              return tooltipItems[0].label;
            },
            label: function(tooltipItem, data) {
              const empresa = data.labels[tooltipItem.index];
              const ventas = data.datasets[0].data[tooltipItem.index];
              const total = data.datasets[0].data.reduce((a, b) => a + b, 0);
              const porcentaje = ((ventas / total) * 100).toFixed(1);
              
              const detalleEmpresa = self.detalle.find(d => d.nombreEmpresa === empresa);
              
              let tooltip = `Ventas: ${self.formatPrice(ventas)} (${porcentaje}%)`;
              
              if (detalleEmpresa) {
                return [
                  tooltip,
                  `Unidades: ${self.formatNumber(detalleEmpresa.totalUnidades)}`,
                  `OCs: ${detalleEmpresa.cantidadOCs}`,
                  `Promedio/OC: ${self.formatPrice(detalleEmpresa.promedioVentaPorOC)}`
                ];
              }
              
              return tooltip;
            }
          }
        }
      };
    }
  },

  methods: {
    getColorForEmpresa(empresa) {
      const colores = {
        'GASCO GLP S A': '#0D47A1',
        'GASCO GLP S.A.': '#0D47A1', 
        'ABASTIBLE S.A.': '#FF9800',
        'EMPRESAS LIPIGAS S A': '#ffc107',
        'EMPRESAS LIPIGAS S.A.': '#ffc107'
      };
      return colores[empresa] || '#9E9E9E';
    },

    formatPrice(value) {
      if (!value) return '$0';
      const numValue = parseFloat(value);
      
      if (numValue >= 1000000000) {
        return '$' + (numValue / 1000000000).toFixed(1) + 'B';
      } else if (numValue >= 1000000) {
        return '$' + (numValue / 1000000).toFixed(0) + 'M';
      } else if (numValue >= 1000) {
        return '$' + (numValue / 1000).toFixed(0) + 'K';
      } else {
        return '$' + Math.round(numValue).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
    },

    formatNumber(value) {
      if (!value) return '0';
      const numValue = Math.round(parseFloat(value));
      return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },

    renderChart() {
      if (this.chartInstance) {
        this.chartInstance.destroy();
      }

      const ctx = this.$refs.canvas.getContext('2d');
      const Chart = window.Chart;

      if (!Chart) {
        console.error('Chart.js no está disponible');
        return;
      }

      this.chartInstance = new Chart(ctx, {
        type: 'doughnut',
        data: this.chartData,
        options: this.chartOptions
      });
    }
  },

  mounted() {
    this.$nextTick(() => {
      this.renderChart();
    });
  },

  watch: {
    chartData: {
      handler() {
        this.$nextTick(() => {
          this.renderChart();
        });
      },
      deep: true
    }
  },

  beforeDestroy() {
    if (this.chartInstance) {
      this.chartInstance.destroy();
    }
  }
};
</script>

<template>
  <div style="position: relative; height: 100%;">
    <div v-if="!labels || labels.length === 0" class="text-xs-center pa-4">
      <v-icon size="48" color="grey lighten-2">business</v-icon>
      <div class="subheading grey--text mt-2">Sin datos de empresas</div>
    </div>
    <canvas v-else ref="canvas"></canvas>
  </div>
</template>